export enum LinkTypeIdentifier {
  deepLink = 'deep_link',
  deepLinkMostRecentResolution = 'deep_link-most_recent_resolution',
  resourceLink = 'resource_link',
  resourceLinkBestGuess = 'resource_link-best_guess',
}
